export class NovoUsuario{
  email: string;
  senha: string;
  confirmacaoSenha: string;
  tipo: number;
  nome: string;
}
